
export const siteUrl = () => JSON.parse(localStorage.getItem('organisation_details'))?.url ?? null
